<p-toast [baseZIndex]="5000" data-testid="app-toast">
  <ng-template let-message pTemplate="message">
    @let content = message.data?.content;

    <div class="flex flex-column agility-toast flex-1">
      <div class="flex-align">
        <i
          class="pi p-1 agility-toast__icon"
          [class]="message.icon ?? 'pi-info-circle'"
          aria-hidden="true"
        ></i>
        <div class="flex flex-1 flex-column pl-3">
          <p class="m-1 agility-toast__title">{{ message.summary }}</p>

          @if (message.data?.bodyType !== 'structured') {
            <div class="m-1 agility-toast__body" [innerHTML]="message.detail"></div>
          } @else if (content) {
            <div
              class="m-1 agility-toast__body"
              [attr.data-testid]="'notification-toast-' + content.severity"
            >
              @if (content.summary) {
                <p class="agility-toast__summary">{{ content.summary }}</p>
              }

              @if (content.linkAction) {
                <app-agility-button
                  [id]="'notification-toast-link-' + content.linkAction.actionId"
                  data-testid="notification-toast-link-button"
                  [label]="content.linkAction.label"
                  [ariaLabel]="content.linkAction.label"
                  buttonType="button"
                  variant="text"
                  size="small"
                  link
                  buttonClass="agility-toast__link-button"
                  (clicked)="onAction(message, content.linkAction.actionId)"
                ></app-agility-button>
              }

              @if (content.lines?.length) {
                <ul class="agility-toast__lines">
                  @for (line of content.lines; track line.text) {
                    <li class="agility-toast__line">
                      <span class="agility-toast__line-text">{{ line.text }}</span>
                      @if (line.copyAction) {
                        <app-agility-button
                          [id]="
                            'notification-toast-copy-' + line.copyAction.actionId
                          "
                          data-testid="notification-toast-copy-button"
                          [ariaLabel]="line.copyAction.tooltip"
                          buttonType="button"
                          icon="pi pi-copy"
                          variant="text"
                          size="small"
                          [tooltipOptions]="{
                            content: line.copyAction.tooltip,
                            position: 'top',
                            disabled: false
                          }"
                          buttonClass="agility-toast__copy-button"
                          (clicked)="onAction(message, line.copyAction.actionId)"
                        ></app-agility-button>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
